var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components'; // Headers

var HeaderStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n  line-height: 1.2;\n  margin-bottom: 0.5em;\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  line-height: 1.2;\n  margin-bottom: 0.5em;\n"])), function (p) {
  return p.theme.textSecondary;
}, function (p) {
  return p.theme.fontWeightLight;
});
var StyledHeader1 = styled.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 2.5rem;\n  ", ";\n"], ["\n  font-size: 2.5rem;\n  ", ";\n"])), HeaderStyle);
var StyledHeader2 = styled.h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 2rem;\n  ", ";\n"], ["\n  font-size: 2rem;\n  ", ";\n"])), HeaderStyle);
var StyledHeader3 = styled.h3(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 1.75rem;\n  ", ";\n"], ["\n  font-size: 1.75rem;\n  ", ";\n"])), HeaderStyle);
var StyledHeader4 = styled.h4(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 1.5rem;\n  ", ";\n"], ["\n  font-size: 1.5rem;\n  ", ";\n"])), HeaderStyle);
var StyledHeader5 = styled.h5(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 1.25rem;\n  ", ";\n"], ["\n  font-size: 1.25rem;\n  ", ";\n"])), HeaderStyle);
var StyledHeader6 = styled.h6(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-size: 1rem;\n  ", ";\n"], ["\n  font-size: 1rem;\n  ", ";\n"])), HeaderStyle);
export var Header1 = function Header1(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledHeader1, props, children);
};
export var Header2 = function Header2(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledHeader2, props, children);
};
export var Header3 = function Header3(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledHeader3, props, children);
};
export var Header4 = function Header4(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledHeader4, props, children);
};
export var Header5 = function Header5(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledHeader5, props, children);
};
export var Header6 = function Header6(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledHeader6, props, children);
}; // Display Headers

var DisplayStyle = css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n  line-height: 1.5;\n  margin-bottom: 0.25em;\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  line-height: 1.5;\n  margin-bottom: 0.25em;\n"])), function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.textPrimary : p.theme.textTertiary;
}, function (p) {
  return p.theme.fontWeightLight;
});
var StyledDisplay1 = styled.h1(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  font-size: 6rem;\n  ", ";\n"], ["\n  font-size: 6rem;\n  ", ";\n"])), DisplayStyle);
var StyledDisplay2 = styled.h2(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  font-size: 5.5rem;\n  ", ";\n"], ["\n  font-size: 5.5rem;\n  ", ";\n"])), DisplayStyle);
var StyledDisplay3 = styled.h3(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  font-size: 4.5rem;\n  ", ";\n"], ["\n  font-size: 4.5rem;\n  ", ";\n"])), DisplayStyle);
var StyledDisplay4 = styled.h4(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  font-size: 3.5rem;\n  ", ";\n"], ["\n  font-size: 3.5rem;\n  ", ";\n"])), DisplayStyle);
export var Display1 = function Display1(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledDisplay1, props, children);
};
export var Display2 = function Display2(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledDisplay2, props, children);
};
export var Display3 = function Display3(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledDisplay3, props, children);
};
export var Display4 = function Display4(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledDisplay4, props, children);
}; // Other Text

var StyledBlockquote = styled.blockquote(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  display: flex;\n  color: ", ";\n  flex-direction: column;\n  font-style: italic;\n  font-weight: ", ";\n  justify-content: center;\n\n  & > p {\n    font-size: 1.2rem;\n    display: flex;\n  }\n  & > footer {\n    display: flex;\n    font-style: normal;\n\n    &::before {\n      content: '\u2014';\n      margin-right: 0.5em;\n    }\n    & > cite {\n      font-style: italic;\n      margin-left: 0.5em;\n    }\n  }\n"], ["\n  display: flex;\n  color: ", ";\n  flex-direction: column;\n  font-style: italic;\n  font-weight: ", ";\n  justify-content: center;\n\n  & > p {\n    font-size: 1.2rem;\n    display: flex;\n  }\n  & > footer {\n    display: flex;\n    font-style: normal;\n\n    &::before {\n      content: '\\u2014';\n      margin-right: 0.5em;\n    }\n    & > cite {\n      font-style: italic;\n      margin-left: 0.5em;\n    }\n  }\n"])), function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.textPrimary : p.theme.textTertiary;
}, function (p) {
  return p.theme.fontWeightNormal;
});
export var Blockquote = function Blockquote(_a) {
  var author = _a.author,
      children = _a.children,
      citation = _a.citation,
      props = __rest(_a, ["author", "children", "citation"]);

  return React.createElement(StyledBlockquote, Object.assign({
    className: "blockquote"
  }, props), React.createElement("p", null, children), (author || citation) && React.createElement("footer", null, author && author, citation && React.createElement("cite", {
    title: citation
  }, citation)));
};
var StyledBrandColor = styled.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (p) {
  return p.theme[p.brand];
});
export var BrandColor = function BrandColor(_a) {
  var brand = _a.brand,
      children = _a.children,
      props = __rest(_a, ["brand", "children"]);

  return React.createElement(StyledBrandColor, Object.assign({
    className: "brand-color-" + brand,
    brand: brand
  }, props), children);
};
var StyledLede = styled.span(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n"], ["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n"])), function (p) {
  return p.theme.highContrast;
}, function (p) {
  return p.theme.fontSizeLg;
}, function (p) {
  return p.theme.fontWeightLight;
});
export var Lede = function Lede(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledLede, Object.assign({
    className: "lede"
  }, props), children);
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;